module.exports = __webpack_public_path__ + "img/dcm-icon.96a18a5f.png";